import { useRef, useEffect } from 'react';

function useEventListener(type, listener) {
    const refHandler = useRef(listener);
    /**
   * Make use of ref.current if the listener changes.
   * This ref updates the handler when it is changed without having to add it to the dependencies in the eventlistener effect
   * this in turn removes many potential re-runs of the effect which would result in many add/remove listeners to the dom.
   */ useEffect(()=>{
        refHandler.current = listener;
    }, [
        listener
    ]);
    useEffect(()=>{
        const isSupported = window && window.addEventListener;
        if (!isSupported) {
            console.warn('Event target does not have an addEventListener method');
            return;
        }
        const handler = (event)=>refHandler.current(event)
        ;
        window.addEventListener(type, handler);
        return ()=>{
            window.removeEventListener(type, handler);
        };
    }, [
        type
    ]);
}

export { useEventListener as default };
//# sourceMappingURL=use-event-listener.js.map
